  в<template>
  <header class="banner-cards">
    <div class="banner-cards__cards">
      <router-link to="/account" >
        <div class="banner-cards__img">
          <img src="@/assets/img/static/b-icon_clientarea-login(1).svg" alt="">
        </div>
        <p>{{$t('personal-data-link')}}</p>
      </router-link>
    </div>
    <div class="banner-cards__cards">
      <router-link to="/purchases" >
        <div class="banner-cards__img">
          <div>
            <span class="badge badge-pill badge-danger" v-if="counters.lots + counters.tenders">{{counters.lots + counters.tenders}}</span>
            <img src="@/assets/img/static/b-icon_partners.svg" alt="">
          </div>
        </div>
        <p>{{$t('purchases-link')}}</p>
      </router-link>
    </div>
    <div class="banner-cards__cards">
      <router-link to="/messages">
        <div class="banner-cards__img">
          <img src="@/assets/img/static/b-icon_envelope(1).svg" alt="">
        </div>
        <p>{{$t('msgs-and-subscriptions-link')}}</p>
      </router-link>
    </div>
    <div class="banner-cards__cards" v-if="permissions.CAN_VIEW_ADMIN">
      <router-link to="/admin">
        <div class="banner-cards__img">
          <div>
            <span class="badge badge-pill badge-danger" v-if="counters.signatures">{{counters.signatures}}</span>
            <img src="@/assets/img/static/b-icon_virtual-manager.svg" alt="">
          </div>
        </div>
        <p>{{$t('admin-link')}}</p>
      </router-link>
    </div>
    <div class="banner-cards__cards" v-if="permissions.CAN_VIEW_ADMIN || permissions.IS_MTS_USER">
      <router-link to="/catalogs">
        <div class="banner-cards__img">
          <div>
            <img src="@/assets/img/static/b-icon_catalogs.svg" alt="">
          </div>
        </div>
        <p>{{$t('catalogs-link')}}</p>
      </router-link>
    </div>
  </header>
</template>

<script>
  export default {
    name: "UserHeader",

    computed: {
      permissions() {
        return this.$store.getters.currentUser.permissions;
      },
      counters() {
        return this.$store.getters.currentUser.counters;
      }
    },

    created() {
      this.runBlockerAction(async() => {
        try {
          await this.$store.dispatch('fetchOrganizationBidRules');
          await this.$store.dispatch('fetchOrganizationAdditionalBidRules');
        }
        catch(e) {
          console.error('unable to fetch list of bid rules', e);
          this.globalErrorHandler(e);
        }
      });

      try {
        this.$store.dispatch('getNotifications');
      }
      catch(e) {}

      this._timer = setInterval(async () => {
        try {
          await this.$store.dispatch('getNotifications');
        }
        catch(e) {}
      }, 30000)
    },

    beforeDestroy() {
      if (this._timer) {
        clearInterval(this._timer);
        this._timer = undefined;
      }
    }
  }
</script>

<style scoped>
  .badge {
    float: right;
    right: 10px;
    top: 0px;
    position: relative;
  }
</style>
